import clsx from "clsx";

import type { ReactNode } from "react";

export default function ContentHeader({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        "flex justify-between flex-wrap lg:border-b lg:border-b-black-200 shrink-0 max-lg:min-h-16 lg:h-[52px] max-lg:pt-6 px-4 items-center gap-3 lg:gap-4",
        className,
      )}
    >
      {children}
    </div>
  );
}
